import script from "./AtomProgressSaltos.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomProgressSaltos.vue?vue&type=script&lang=ts&setup=true"

import "./AtomProgressSaltos.vue?vue&type=style&index=0&id=52598fe8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52598fe8"]])

export default __exports__